<template>
  <b-modal
    @show="onShow"
    dialog-class="md_modal_dialog_full2"
    modal-class="md_modal_full"
    content-class="md_modal_content_full"
    header-class="dlg_header no_border"
    :visible="visible"
    hide-footer
    hide-backdrop
    no-close-on-backdrop
    @hide="onCancel"
  >
    <template #modal-header="{close}">
      <div class="dlg_title1 width_100" style="text-align: center">{{ $t('more.set_cur_location') }}</div>
      <b-button class="dlg_close_btn" variant="white" @click="onCancel">
        <b-img :src="require('../../../assets/image/ic_close2.png')" style="height: 1em; margin-left: 7px; margin-right: 3px; "/>
      </b-button>
    </template>
    <iframe ref="webref" id='webref' @load="onLoadEnd" class="map no_border" src="https://app.madepf.com/web_map4.html"></iframe>
    <div class="align-vertical info_wrapper">
      <div class="align-vertical info">
        <label class="address">{{show_address}}</label>
        <b-button variant="white" class="label" @click="onChangeAddress">
          {{address_method}}
        </b-button>
      </div>
      <b-button variant="primary" class="btn1 btn1_text" @click="onConfirm">
        {{$t('more.set_address')}}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import Utils from "../../../config/utils";
export default {
  name: "MapPopup",
  props:{
    visible:{
      type:Boolean,
      default:false,
    },
  },
  data() {
    return {
      address: this.myinfo.address,
      road_name: this.myinfo.roadAddress,
      latitude: Number(this.myinfo.latitude),
      longitude: Number(this.myinfo.longitude),
      mapZoomValue: 14.5,
      address_method: this.$t('more.view_by'),
      show_address: this.myinfo.address,
      temp_address: "",
    }
  },
  mounted() {
    window.addEventListener('message', this.onMessage, false)
  },
  beforeDestroy () {
    window.removeEventListener('message', this.onMessage)
  },
  created() {
    this.show_address = this.show_address.replace((this.myinfo.address.split(' '))[0], '');
  },
  methods:{
    onShow() {

    },
    onChangeAddress() {
      if (this.address_method == this.$t('more.view_by')) {
        if (this.road_name == "") {
          this.temp_address = "";
        } else {
          this.temp_address = this.road_name;
          this.temp_address = this.temp_address.replace((this.road_name.split(' '))[0],'');
        }

        Utils.setState(this,{address_method: '지번 주소로 보기', show_address: this.temp_address})
      } else {
        if (this.address == "") {
          this.temp_address = ""
        } else {
          this.temp_address = this.address;
          this.temp_address = this.temp_address.replace((this.address.split(' '))[0],'');
        }
        Utils.setState(this,{address_method: this.$t('more.view_by'), show_address: this.temp_address});
      }
    },

    onCancel() {
      this.$emit('update:visible', false);
    },

    onConfirm() {
      this.myinfo.tmpLatitude = this.latitude;
      this.myinfo.tmpLongitude = this.longitude;
      this.$emit('onConfirm',this.address, this.road_name);
    },

    onLoadEnd() {
      //TODO:
      this.$refs.webref.contentWindow.postMessage(
        {
          type: '1',
          lat: this.myinfo.latitude,
          lon: this.myinfo.longitude,
        }, '*'
      );
    },

    onMessage(e) {
      //TODO:
      var data = JSON.parse(e.data);
      if (data.type == '1') {

      } else if (data.type == '2') {
        Utils.setState(this,{
          latitude: data.lat,
          longitude: data.lon,
          address: data.jibun,
          road_name: data.road
        });

        if (this.address_method == this.$t('more.view_by')) {
          if (this.address == "") {
            this.temp_address = ""
          } else {
            this.temp_address = this.address;
            this.temp_address = this.temp_address.replace((this.address.split(' '))[0],'');
          }
          Utils.setState(this,{show_address: this.temp_address});
        } else {
          if (this.road_name == "") {
            this.temp_address = ""
          } else {
            this.temp_address = this.road_name;
            this.temp_address = this.temp_address.replace((this.road_name.split(' '))[0],'');
          }
          Utils.setState(this,{show_address: this.temp_address});
        }
        // this.getCurrentAddress(data.lat, data.lon);
      }
    },

    onMapClickHandler(e) {
      //TODO:
      Utils.setState(this,{latitude: e['latitude'], longitude: e['longitude']});
      this.getCurrentAddress(e['latitude'], e['longitude']);
      // Utils.setState({ mapCenter: { latitude:Number(e['latitude']), longitude:Number(e['longitude']) } });
    },

    getCurrentAddress(lat, lon) {
      //TODO:
      fetch('https://dapi.kakao.com/v2/local/geo/coord2address.json?input_coord=WGS84&x=' + lon + '&y=' + lat, {
        headers: {
          'Authorization': 'KakaoAK e398bc45713e267138212b3e3da37c80',
        }
      })
        .then((response) => response.json())
        .then((responseJson) => {
          if (responseJson.meta.total_count > 0) {
            var addressInfo = responseJson.documents[0];
            var jibunInfo = addressInfo.address;
            var roadInfo = addressInfo.road_address;
            var roadAddress = "";
            if (roadInfo != null) {
              roadAddress = roadInfo.address_name;
            }

            Utils.setState(this,{address: jibunInfo.address_name, road_name: roadAddress})

          } else {

          }

        })
        .catch((error) => {
          console.log(error);
        });
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/_vars.scss";
.map {
  background-color: #bbe2c6;
  height: calc(100% - 170px);
  width: 100%;
  overflow: auto;
}
.close_btn {
  width: 30px;
  height: 30px;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 10px;
  right: 15px;
}
.info_wrapper {position: absolute; bottom: 16px; left: 0; width: 100%; padding-left: 35px; padding-right: 35px}
.info {height: 104px; border-radius: 8px; background-color: white; align-items: center; justify-content: center}
.address {color: black; font-size: $fs_22; font-family: $korean_gd_15_r; margin-bottom: 0px;}
.label {color: $c_457fff; font-size: $fs_20; font-family: $korean_gd_15_r; margin-top: 0px;}
.btn1 {
  height: $button_height1;
  width: 100%;
  margin-top: 6px;
  background-color: $c_457fff;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
}
.btn1_text {color: white; font-size: $fs_18; font-family: $korean_gd_15_r; }
</style>



// WEBPACK FOOTER //
// src/components/controls/popup/MapPopup.vue